import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomBodyModal from "../../shared/components/modal/CustomBodyModal";
import { Col, Row } from "react-bootstrap";
import {
  Button,
  DataTableComponent,
  SearchField,
} from "../../shared/components";
import {
  AddIcon,
  BlueBoxIcon,
  CrossIcon,
  SearchIcon,
} from "../../assets/icons/iconsProvider";
import { EMPTY_STRING } from "../../constants";
import {
  getAllTaxRule,
  handleMapSelectedOptionsInEdit,
} from "../../shared/utility";
import { getCustomTaxRulesColumn } from "../../shared/utilities/taxRateUtility";
import { connect } from "react-redux";
import { storeActions } from "../../redux/actions";
const defaultGridState = {
  pageSize: 50,
  pageIndex: 0,
  sortBy: [],
};
const CustomTaxRulesModal = ({
  show = false,
  onHide = () => {},
  showAddCustomSalesTaxRuleModal,
  setShowAddCustomSalesTaxRuleModal,
  customTaxRules,
  getCustomSalesTaxRules,
  currentStore,
  isEditingSaleTax,
  setIsEditingSaleTax,
  currentEditingSaleTax,
  setCurrentEditingSaleTax,
  onAddRuleClick,
  deleteSaleTax,
}) => {
  const [searchText, setSearchText] = React.useState("");
  const [columns, setColumns] = useState([]);
  const [defaultSortFieldId, setDefaultSortFieldId] = useState("setBy");
  const [gridState, setGridState] = useState(defaultGridState);
  let numOfRenders = useRef(0);
  const taxRules = getAllTaxRule(customTaxRules);
  const handleEditClick = useCallback(
    (row) => {
      const mappedTaxGroup = handleMapSelectedOptionsInEdit(
        row.taxGroup || [],
        row.taxType
      );

      const editingData = {
        ...row,
        taxGroup: mappedTaxGroup,
      };

      setCurrentEditingSaleTax(editingData);
      setIsEditingSaleTax(true);
      onAddRuleClick?.(editingData);
    },
    [setCurrentEditingSaleTax, setIsEditingSaleTax, onAddRuleClick]
  );

  const handleDeleteClick = useCallback(
    (row) => {
      deleteSaleTax(currentStore?.id, row);
    },
    [currentStore?.id, deleteSaleTax]
  );
  const updateGridState = (newGridState) => {
    setGridState(newGridState);
  };
  useEffect(() => {
    if (currentStore?.id && show) {
      getCustomSalesTaxRules(currentStore?.id);
    }
  }, [currentStore?.id, getCustomSalesTaxRules, show]);

  useEffect(() => {
    setColumns(getCustomTaxRulesColumn({ handleEditClick, handleDeleteClick }));
  }, [currentStore, handleDeleteClick, handleEditClick]);

  const clearSearchText = () => {
    setSearchText("");
    numOfRenders.current++;
  };
  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };
  const handleFilterData = () => {
    const searchLower = String(searchText).toLowerCase();
    return taxRules.filter((row) =>
      row.taxGroup?.some((item) =>
        (item.categoryName || EMPTY_STRING).toLowerCase().includes(searchLower)
      )
    );
  };
  return (
    <CustomBodyModal
      show={show}
      onHide={onHide}
      title="Custom Tax Rules"
      className=".overflow-visible"
    >
      <Row className="m-0 mb-3 p-0 w-100">
        <Col md={9} className="">
          <SearchField
            onChange={(e) => setSearchText(e.target.value)}
            IconImage={SearchIcon}
            label="Search"
            placeHolder="Type or Scan"
            value={searchText}
            CrossIcon={searchText ? CrossIcon : ""}
            clearSearchText={clearSearchText}
            BlueBoxIcon={BlueBoxIcon}
          />
        </Col>
        <Col
          md={3}
          className="d-flex justify-content-end align-items-end gap-3"
        >
          <Button
            label={"Add Rule"}
            IconImage={AddIcon}
            handleClick={() => {
              setCurrentEditingSaleTax({});
              setIsEditingSaleTax(false);
              onAddRuleClick?.();
            }}
            className="w-100"
          />
        </Col>
      </Row>
      <Row className="m-0 p-0 w-100">
        <DataTableComponent
          resizableColumns={false}
          className="editable-table"
          key={numOfRenders.current}
          columns={columns}
          tableId="customTaxRulesTable"
          data={searchText ? handleFilterData() : taxRules}
          onSort={onTableSort}
          defaultSortFieldId={defaultSortFieldId}
          total={searchText ? handleFilterData()?.length : taxRules?.length}
          gridState={gridState}
          setGridState={updateGridState}
        />
      </Row>
    </CustomBodyModal>
  );
};
const mapStateToProps = (state) => {
  return {
    customTaxRules: state.store?.customTaxRules,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getCustomSalesTaxRules: (storeId) =>
    dispatch(storeActions.getCustomSalesTaxRules(storeId)),
  deleteSaleTax: (storeId, taxRateId) =>
    dispatch(storeActions.deleteSaleTax(storeId, taxRateId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomTaxRulesModal);
